module.exports = __webpack_public_path__ + "wallet.svg?9f8cffe400233439212e2b99b79aec07";


//////////////////
// WEBPACK FOOTER
// ./Content/src/assets/MyProgress/wallet.svg
// module id = 869
// module chunks = 1